module.exports = __webpack_public_path__ + "images/icons/button-arrow-dc4823a5.svg";